<!-- requests/panding -->
<template>
  <RequestsTableRedesigned
    :api-url-props="'/v2/requests?pending=true'"
    title="Pending Requests"
  />
</template>

<script>

import RequestsTableRedesigned from './RequestsTableRedesigned.vue'

export default {
  components: {
    RequestsTableRedesigned,
  },

}
</script>
